import React from 'react'
import { Link } from 'react-router-dom';
function Result({searchValue, data, handleIMDB}) {
  let text = "";
  return (
    <div>
        
        <div className="result">
            
            <p>Movie result for '{searchValue}'</p>
            <div className="feed">
                {
                    
                    data.Search.map((item)=>{
                        console.log(item);
                        return (
                            <div className="posts" key={item.imdbID}>
                                <div className='image'>
                                 <img src={`${item.Poster}`} alt=""  />
                                </div>
                                <div id='title'>
                                    Title : {item.Title}
                                </div>
                                <div>
                                    Type : {item.Type}
                                </div>
                                <div>
                                    Year : {item.Year}
                                </div>
                                <div id='post-btn'>

                                <Link to={ `/movies/${item.imdbID}`}>
                                <button >Know More</button>
                                </Link>

                                    
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </div>
  )
}

export default Result